if (!customElements.get('td-recommendation-card-layout')) {
  class TdRecommendationCardLayout extends HTMLElement {
    connectedCallback() {
      this.resizeObserver = new ResizeObserver(([entry]) => {
        const width = entry.contentRect.width;

        if (width === this.observedWidth) return;

        this.observedWidth = width;
        this.scheduleDescriptionLayout();
      });
      this.resizeObserver.observe(this);

      this.mutationObserver = new MutationObserver(() => this.scheduleDescriptionLayout());
      this.mutationObserver.observe(this, {
        childList: true,
        characterData: true,
        subtree: true,
      });

      document.fonts?.ready.then(() => this.scheduleDescriptionLayout());
      this.scheduleDescriptionLayout();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      cancelAnimationFrame(this.layoutFrame);
    }

    scheduleDescriptionLayout() {
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => this.equalizeDescriptions());
    }

    equalizeDescriptions() {
      const descriptions = Array.from(this.querySelectorAll('.td-product-card__description'));

      if (!descriptions.length || this.offsetWidth === 0) return;

      this.style.removeProperty('--td-recommendation-description-height');

      const tallestDescription = Math.ceil(
        Math.max(...descriptions.map((description) => description.getBoundingClientRect().height))
      );

      this.style.setProperty('--td-recommendation-description-height', `${tallestDescription}px`);
    }
  }

  customElements.define('td-recommendation-card-layout', TdRecommendationCardLayout);
}
